/****   http.js   ****/
// 导入封装好的axios实例
import request from './request.js'
import common from '../common/common.js'
import router from '../router'
import { saveAs } from 'file-saver'
import { Notification, MessageBox, Message, Loading } from 'element-ui'


// 通用下载方法
function downloads(data, filename) {
	console.log(data)
  const blob = new Blob([data])
	console.log(blob)
  saveAs(blob, filename)
}

/**
 * methods: 请求
 * @param url 请求地址 
 * @param params 请求参数
 */
function get(url, params, headers_config) {
    // let sign=''
    // if(params){
    // 	sign = common.jsrsasignData(params)
    // }
    // console.log(sign)
    const config = {
        method: 'get',
        url: url,
        headers_config: headers_config
    }
    // params['token'] = localStorage.getItem("token-bank");
    if (params) config.params = params
        // config.sign = sign
    return request(config)
}

function post(url, params, headers_config) {
    // let sign =common.jsrsasignData(params)
    // console.log(sign)
    const config = {
        method: 'post',
        url: url,
        headers_config: headers_config
    }
    // params['token'] = localStorage.getItem("token-bank");
    // params['power_id'] = router.history.current.query.powerId;
    if (params) config.data = params
    return request(config)
}
function put(url, params, headers_config) {
    // let sign =common.jsrsasignData(params)
    // console.log(sign)
    const config = {
        method: 'put',
        url: url,
        headers_config: headers_config
    }
    // params['token'] = localStorage.getItem("token-bank");
    // params['power_id'] = router.history.current.query.powerId;
    if (params) config.data = params
    return request(config)
}

function delete1(url, params, headers_config) {
    // let sign =common.jsrsasignData(params)
    // console.log(sign)
    const config = {
        method: 'delete',
        url: url,
        headers_config: headers_config
    }
    if (params) config.data = params
        // if(params) config.params = params
        // config.data={}
        // config.data=params
    return request(config)
}

function downloadUrl(url) {
    // let sign =common.jsrsasignData(params)
    // console.log(sign)
    const config = {
        method: 'get',
        url: url,
        responseType: 'blob',
    }
    return request(config)
}
// put(url,params){
//     const config = {
//         methods: 'put',
//         url:url
//     }
//     if(params) config.params = params
//     return request(config)
// },

//导出
export default {
    get,
    post,
		put,
		downloads,
    delete1,
    downloadUrl
}